<ng-container *ngIf="!rsbExpansionPanel">
    <mat-accordion class="left-side-bar" [multi]="true">
        <mat-expansion-panel *ngFor="let panel of expansionPanels" [expanded]="panel.isExpanded" (opened)="openedEvent()" (closed)="closedEvent()" (click)="expansionClickEvent(panel)">
            <mat-expansion-panel-header *ngIf="panel.sectionItems" [matTooltip]="panel.tooltipText" [collapsedHeight]="'38px'" [expandedHeight]="'38px'">
                <itb-icon class="lsb-group" [className]="'icon-group2'"></itb-icon>
                <itb-text [className]="panel.textClassName" [text]="panel.sectionName"></itb-text>
            </mat-expansion-panel-header>
            <mat-expansion-panel-header *ngIf="!panel.sectionItems" class="disable-lsb-expansion" [collapsedHeight]="'38px'" [expandedHeight]="'38px'" #panelH (click)="panelH._toggle()">
                <itb-icon class="lsb-group" [className]="'icon-group2'"></itb-icon>
                <itb-text [className]="panel.textClassName" [text]="panel.sectionName"></itb-text>
            </mat-expansion-panel-header>
            <itb-expansion-panel-list-item (onClickHandler)="onClick($event)" (onTextClickHandler)="onTextClick($event)" [itemList]="panel.sectionItems">
            </itb-expansion-panel-list-item>
        </mat-expansion-panel>
    </mat-accordion>
</ng-container>

<ng-container *ngIf="rsbExpansionPanel">
    <mat-accordion class="right-side-bar">
        <mat-expansion-panel *ngFor="let panel of expansionPanels" [expanded]="panel.isExpanded">
            <mat-expansion-panel-header [matTooltip]="panel.tooltipText" [collapsedHeight]="'42px'" [expandedHeight]="'42px'" (opened)="openedEvent()" (closed)="closedEvent()" (click)="expansionClickEvent(panel)">
                <itb-icon *ngIf="!isExpanded" [className]="panel.iconClassName" [tooltipText]="panel.tooltipText">
                </itb-icon>
                <itb-text [className]="panel.textClassName" [text]="panel.sectionName"></itb-text>
            </mat-expansion-panel-header>
            <itb-rsb-item-list [rsbListItems]="panel.rsbListItems" (onClickHandler)="onClick($event)"></itb-rsb-item-list>
        </mat-expansion-panel>
    </mat-accordion>


<div class="{{className}}" (click)="expFooterClickHandler()">
    <itb-icon [className]="iconClassName"></itb-icon>
    <itb-text [className]="textClassName" [text]="text"></itb-text>
    <itb-button-group [buttons]="buttons" [className]="buttonGroupClassName"></itb-button-group>
</div>

</ng-container>